import { DrillScoring } from '@core';
import { DrillDto, DrillSessionPreviewDto, DrillType } from '@drills/infra';
import { DrillSessionPreviewViewModel, DrillTypeVariant, DrillViewModel } from '../models';
import { drillScoringLabelMapper } from './drill-scoring-label.mapper';
import { drillScoringShortMapper } from './drill-scoring-short.mapper';
import { drillTypeLabelMapper } from './drill-type-label.mapper';

const typeVariant = (type: DrillType): DrillTypeVariant => (type === DrillType.Live ? 'live' : 'dry');

export const toDrillSessionPreviewViewModel = (preview: DrillSessionPreviewDto): DrillSessionPreviewViewModel => {
  const base: { sessionId: string; date: Date; runsCount: number } = {
    sessionId: preview.sessionId,
    date: new Date(preview.date),
    runsCount: preview.runsCount
  };
  switch (preview.scoring) {
    case DrillScoring.RepsOnly:
      return { ...base, scoring: preview.scoring, totalReps: preview.totalReps };
    case DrillScoring.TimePerRep:
      return { ...base, scoring: preview.scoring, bestTime: preview.bestTime };
    case DrillScoring.HitFactor:
      return { ...base, scoring: preview.scoring, bestHitFactor: preview.bestHitFactor };
  }
};

export const toDrillViewModel = (dto: DrillDto): DrillViewModel => {
  const recentSessions: readonly DrillSessionPreviewViewModel[] =
    dto.recentSessions.map(toDrillSessionPreviewViewModel);
  return {
    id: dto.id,
    name: dto.name,
    type: dto.type,
    typeLabel: drillTypeLabelMapper(dto.type),
    typeVariant: typeVariant(dto.type),
    scoring: dto.scoring,
    scoringLabel: drillScoringLabelMapper(dto.scoring),
    scoringShort: drillScoringShortMapper(dto.scoring),
    shotsCount: dto.shotsCount,
    description: dto.description,
    favorite: dto.favorite,
    createdAt: new Date(dto.createdAt),
    updatedAt: new Date(dto.updatedAt),
    lastUsedAt: dto.lastUsedAt === null ? null : new Date(dto.lastUsedAt),
    recentSessions
  };
};
